import { YearInterceptor } from './shared/helpers/year.interceptor';
import { DateService } from './shared/services/date.service';
import { AuthGuardService } from './shared/services/auth-guard.service';
import { LoggedUserService } from './shared/services/loggeduser.service';
import { HttpService } from './shared/services/http.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
  ],
  providers: [
    HttpService,
    LoggedUserService,
    AuthGuardService,
    DateService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: YearInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
